import React, { useContext, useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Configure from "../components/Configure";
import NewPlate from "../components/NewPlate";
import Login from "./Login";
import LoginOtp from "./LoginOtp";
import Product from './Product';
import Checkout from './Checkout';
import LayoutDesign from "./LayoutDesign";
import Thankyou from './Thankyou';
import Menu from "./Menu";
import Ingredients from "./Ingredients";
import LandingPage from "./LandingPage";
import RatingandReview from "./RatingandReview";
import UserDashboard from './UserDashboard';
import SignUp from "./SignUp";
import SocialMediaReview from "./SocialMediaReview";
import Plates from "./Plates";
import PlatesContent from "./dashboard/PlatesContent";
import OrdersContent from "./dashboard/OrdersContent";
import MenuContent from "./dashboard/MenuContent";
import ReviewProvider from "./ReviewProvider";
import DashboardContent from "./dashboard/DashboardContent";
import NetworkError from "./NetworkError";
import ConditionalRoute from '../globals/ConditionalGuard';
import { isAuthenticated } from "../globals/helper";
import Profile from "./dashboard/Profile";
import ResetPassword from "./ResetPassword";
import Specials from "./Specials";
import Offers from "./dashboard/Offers";
import ManualOrderCreation from "./ManualOrderCreation";
import CustomerOrders from './dashboard/CustomerOrders';
import CustomerPlates from './dashboard/CustomerPlates';
import OrderDetails from "./dashboard/OrderDetails";
import Gallery from "./dashboard/Gallery";
import { useAuth } from "../globals/AuthContext";
import ViewClicks from "./dashboard/ViewClicks";
import Networks from "./dashboard/Networks";
import BusinessPhotos from "./dashboard/BusinessPhotos";
import BusinessGraphs from './dashboard/BusinessGraphs';
import BusinessMenu from "./dashboard/BusinessMenu";
import UserBusinessReports from "./dashboard/UserBusinessReports";
import { BusinessContext } from "./BusinessContext";
import { isAdminAccount } from "../globals/userRoles";

const ProtectedRoute = ({ children }) => {
  const { user, authReady } = useAuth();

  if (!authReady) return null; // or show a loading spinner

  if (!user) return <Navigate to="/login" />;
  return children;
};

const AdminRoute = ({ children }) => {
  const { userdetails, fetchUserDetails } = useContext(BusinessContext);
  const [checked, setChecked] = useState(Boolean(userdetails?.account_type));
  const [fetchedUserDetails, setFetchedUserDetails] = useState(null);

  useEffect(() => {
    if (userdetails?.account_type) {
      setChecked(true);
      return;
    }
    if (checked) return;

    let mounted = true;
    Promise.resolve(fetchUserDetails?.()).then((user) => {
      if (!mounted) return;
      setFetchedUserDetails(user);
      setChecked(true);
    });

    return () => {
      mounted = false;
    };
  }, [checked, fetchUserDetails, userdetails?.account_type]);

  if (!checked) return null;

  if (!isAdminAccount(userdetails) && !isAdminAccount(fetchedUserDetails)) {
    return <Navigate to="/dashboard/dashboard" replace />;
  }

  return children;
};

// const ProtectedRoute = ({ children }) => {
//   if (!isAuthenticated()) {
//     return <Navigate to="/login" />;
//   }


//   return children;
// };


const AuthRoute = ({ children }) => {
  const { user, authReady } = useAuth();

  if (!authReady) return null;

  if (user) return <Navigate to="/dashboard" />;
  return children;
};

// const AuthRoute = ({ children }) => {
//   if (isAuthenticated()) {
//     return <Navigate to="/dashboard" />;
//   }


//   return children;
// };


const AppRouter = () => {

  return (
    <Routes>
      <Route path="/layoutdesign" element={<LayoutDesign />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/configure" element={<Configure />} />
      <Route path="/newplate" element={<NewPlate />} />
      <Route path="/login" element={<AuthRoute><Login /></AuthRoute>} />
      <Route path="/loginotp" element={< LoginOtp />} />
      <Route path="/place/:code" element={<LandingPage />} />
      <Route path="/r/*" element={<ConditionalRoute/>}/>
      <Route path="/signup/:code" element={<AuthRoute><SignUp /></AuthRoute>} />
      <Route path="/signup" element={<AuthRoute><SignUp /></AuthRoute>} />
      <Route path="/product" element={< Product />} />
      <Route path="/checkout" element={< Checkout />} />
      <Route path="/thankyou" element={<Thankyou />} />
      <Route path="/menu/:code" element={<Menu />} />
      <Route path="/ingredients" element={<Ingredients />} />
      <Route path="/offers/:code" element={<Specials/>}/>
  
      <Route path="/ratings" element={<RatingandReview />} />
      <Route path="/networkerror" element={<NetworkError />} />

      {/* Dashboard Routes */}
      <Route path="/dashboard" element={<UserDashboard />}>
        <Route index element={<Navigate to="/dashboard/dashboard" replace />} />
        <Route path="dashboard" element={<ProtectedRoute><DashboardContent /></ProtectedRoute>} />
        <Route path="/dashboard/genietags" element={<ProtectedRoute><PlatesContent /></ProtectedRoute>} />
        <Route path="/dashboard/orders" element={<ProtectedRoute><OrdersContent /></ProtectedRoute>} />
        <Route path="/dashboard/offers" element={<ProtectedRoute><Offers/></ProtectedRoute>}/>
        <Route path="/dashboard/menu" element={<ProtectedRoute><MenuContent /></ProtectedRoute>} />
        <Route path="/dashboard/sociallinks" element={<ProtectedRoute><ReviewProvider /></ProtectedRoute>} />
        <Route path="/dashboard/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/dashboard/photos" element={<ProtectedRoute><Gallery /></ProtectedRoute>} />
        <Route path="/dashboard/customerorders" element={<ProtectedRoute><AdminRoute><CustomerOrders /></AdminRoute></ProtectedRoute>} />
        <Route path="/dashboard/businessreports" element={<ProtectedRoute><CustomerPlates /></ProtectedRoute>} />
        <Route path="/dashboard/manualordercreation" element={<ProtectedRoute><ManualOrderCreation /></ProtectedRoute>} />
        <Route path="/dashboard/viewclicks/:businessId" element={<ProtectedRoute><ViewClicks /></ProtectedRoute>} />
        <Route path="/dashboard/networks/:businessId" element={<ProtectedRoute><Networks /></ProtectedRoute>} />
        <Route path="/dashboard/businessphotos/:businessId" element={<ProtectedRoute><BusinessPhotos /></ProtectedRoute>} />
        <Route path="/dashboard/businessgraphs/:businessId" element={<ProtectedRoute><BusinessGraphs /></ProtectedRoute>} />
        <Route path="/dashboard/businessmenu/:businessId" element={<ProtectedRoute><BusinessMenu /></ProtectedRoute>} />
        <Route path="/dashboard/businessreport" element={<ProtectedRoute><UserBusinessReports/></ProtectedRoute>} />
      </Route>

      <Route path="/socialmediareview/:code" element={<ProtectedRoute><SocialMediaReview /></ProtectedRoute>} />
      <Route path="/plates/:code" element={<ProtectedRoute><Plates /></ProtectedRoute>} />
      <Route path="/resetpassword" element={<ResetPassword></ResetPassword>}/>
      <Route path="*" element={<Navigate to="/networkerror" replace />} />
    </Routes>
  );
};

export default AppRouter;
